import { Record } from 'immutable';

const MultiAgencyRecord = Record({
  agencyId: null,
  agencyName: null
});

export class MultiAgency extends MultiAgencyRecord {
  agencyId: string;
  agencyName: string;
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/multi-agency.ts